module.exports = __webpack_public_path__ + "r-v3/img/camera_on.dcde2d03.svg";